module.exports = __webpack_public_path__ + "img/logo1 (30).94c6f374.jpg";